<template>
  <div class="d-flex flex-column destination-whats-happening">
    <div class="d-flex align-items-center justify-content-between pad-bottom" data-aos="fade-up">
      <div class="title">{{ title }}</div>
      <div class="see-all">
        <RouterLink :to="routeToAll">See all</RouterLink>
      </div>
    </div>

    <div v-if="whatsHappeningData.length <= 3" class="row">
      <div
        v-for="(item, i) in whatsHappeningData"
        :key="`${routeAllName}_${item.id}_${i}`"
        class="col-sm-6 col-lg-4"
        data-aos="fade-up"
      >
        <DestinationWhatsHappeningItem :item="item" />
      </div>
    </div>
    <div v-else class="row">
      <AppSwiper
        :data="whatsHappeningData"
        :data-type="type"
        :disable-padding-x="false"
        :has-more-data="hasMoreData"
        :route="routeName"
        :title-event="title"
      />
    </div>
  </div>
</template>

<script>
import { makeRouteQueryFromData } from '@/helpers/routerHelper';
import { FILTER_TYPE_DESTINATIONS } from '@/helpers/data-filter/DataFilterTypes';

import AppSwiper from '@/components/partials/elements/AppSwiper';
import DataItemDates from '@/components/partials/DataItemDates';
import DestinationWhatsHappeningItem from '@/components/destination/DestinationWhatsHappeningItem';

export default {
  components: { DestinationWhatsHappeningItem, DataItemDates, AppSwiper },
  props: {
    destination: {
      type: Object,
      required: true,
    },
    childDestinations: {
      type: Array,
      default: () => [],
    },
    hasMoreData: {
      type: Boolean,
      default: false,
    },
    isMobileScreen: {
      type: Boolean,
      default: false,
    },
    routeAllName: {
      type: String,
      required: true,
    },
    routeName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    whatsHappeningData: {
      type: Array,
      required: true,
    },
  },
  computed: {
    routeToAll() {
      const query = makeRouteQueryFromData({
        [FILTER_TYPE_DESTINATIONS]: this.childDestinations?.length ? this.childDestinations : [this.destination.slug],
      });
      return { name: this.routeAllName, query };
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.destination-whats-happening {
  margin-bottom: 50px;

  @media (min-width: vars.$tablet-break-point) {
    margin-bottom: 80px;
  }
}

.pad-bottom {
  padding-bottom: 30px;

  @media (min-width: vars.$tablet-break-point) {
    padding-bottom: 50px;
  }
}

.title {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: vars.$c-dark-gray;

  @media (min-width: vars.$tablet-break-point) {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 6px;
  }

  @media (min-width: vars.$desktop-lg-992-break-point) {
    font-size: 26px;
    letter-spacing: 8.33px;
  }
}

.see-all {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 1.11px;
  text-transform: uppercase;
  color: vars.$c-dark-gray;

  a {
    color: inherit;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  @media (min-width: vars.$tablet-break-point) {
    font-size: 20px;
  }
}
</style>
